import React from 'react';
import { Quote } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function OpeningHook() {
  return <section className="py-20 md:py-32 bg-offwhite-dark relative overflow-hidden" data-id="element-201">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-16 bg-navy/10" data-id="element-202"></div>

      <div className="container mx-auto px-4 md:px-6 max-w-4xl relative z-10" data-id="element-203">
        <FadeIn data-id="element-204">
          <div className="flex justify-center mb-8" data-id="element-205">
            <div className="w-16 h-16 rounded-full bg-navy/5 flex items-center justify-center text-navy/20" data-id="element-206">
              <Quote size={32} data-id="element-207" />
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-208">
          <p className="text-2xl md:text-3xl lg:text-4xl font-serif italic text-navy text-center leading-relaxed mb-8" data-id="element-209">
            "Sabes exactamente de qué sentimiento hablo. Es ese nudo en el
            estómago el domingo por la noche, sabiendo que mañana tu hijo
            entrará por las puertas del colegio a enfrentar un infierno que no
            merece."
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-210">
          <p className="text-lg md:text-xl text-navy/70 text-center leading-relaxed max-w-3xl mx-auto" data-id="element-211">
            Has intentado decirle que los ignore, has hablado con profesores que
            no hacen nada, e incluso has pensado en decirle que se defienda a
            golpes. Pero nada cambia.{' '}
            <strong className="text-navy font-semibold" data-id="element-212">
              El silencio de tu hijo se hace más profundo y el miedo en sus ojos
              es cada vez más difícil de ver.
            </strong>
          </p>
        </FadeIn>
      </div>
    </section>;
}